import React, { Component } from "react";
import { MDBBtn, MDBModalBody, MDBModalHeader, MDBRow, MDBCol, MDBInput } from "mdbreact";
import { withTranslation } from "react-i18next";

class AddRuckusR1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: "",
            url: "",
            tenantId: "",
            apiClientId: "",
            apiClientSecret: "",
            enableSync: true,
        };
    }

    submitAddRuckusR1 = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";

        if (
            this.state.controllerName !== undefined &&
            this.state.controllerName !== "" &&
            this.state.url !== undefined &&
            this.state.url !== "" &&
            this.state.tenantId !== undefined &&
            this.state.tenantId !== "" &&
            this.state.apiClientId !== undefined &&
            this.state.apiClientId !== "" &&
            this.state.apiClientSecret !== undefined &&
            this.state.apiClientSecret !== ""
        ) {
            this.props.submitAddRuckusR1(
                this.state.controllerName,
                this.state.url,
                this.state.tenantId,
                this.state.apiClientId,
                this.state.apiClientSecret,
                this.state.enableSync
            );
        }
    };

    changeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    toggleEnableSync = () => {
        this.setState({ enableSync: !this.state.enableSync });
    };

    render() {
        const { t } = this.props;
        return (
            <>
                <MDBModalHeader toggle={this.props.toggleAddRuckusR1}>
                    <h4>Add New Ruckus R1 Controller</h4>
                    <p>{t("addnewresident.required")}</p>
                </MDBModalHeader>
                <MDBModalBody>
                    <form
                        className="needs-validation"
                        onSubmit={this.submitAddRuckusR1}
                        noValidate
                    >
                        <MDBRow>
                            <MDBCol col="12" sm="12" lg="12">
                                <label
                                    htmlFor="controllerName"
                                    className="black-text"
                                >
                                    Controller Name *
                                </label>
                                <input
                                    required
                                    id="controllerName"
                                    name="controllerName"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    value={this.state.controllerName}
                                    placeholder="Enter controller name"
                                />
                                <div className="invalid-feedback">
                                    Please provide a controller name.
                                </div>
                            </MDBCol>
                        </MDBRow>

                        <MDBRow>
                            <MDBCol col="12" sm="12" lg="12">
                                <label
                                    htmlFor="url"
                                    className="black-text"
                                >
                                    URL *
                                </label>
                                <input
                                    required
                                    id="url"
                                    name="url"
                                    type="url"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    value={this.state.url}
                                    placeholder="https://api.ruckus.cloud"
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid URL.
                                </div>
                            </MDBCol>
                        </MDBRow>

                        <MDBRow>
                            <MDBCol col="12" sm="12" lg="12">
                                <label
                                    htmlFor="tenantId"
                                    className="black-text"
                                >
                                    Tenant ID *
                                </label>
                                <input
                                    required
                                    id="tenantId"
                                    name="tenantId"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    value={this.state.tenantId}
                                    placeholder="Enter tenant ID"
                                />
                                <div className="invalid-feedback">
                                    Please provide a tenant ID.
                                </div>
                            </MDBCol>
                        </MDBRow>

                        <MDBRow>
                            <MDBCol col="12" sm="12" lg="12">
                                <label
                                    htmlFor="apiClientId"
                                    className="black-text"
                                >
                                    API Client ID *
                                </label>
                                <input
                                    required
                                    id="apiClientId"
                                    name="apiClientId"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    value={this.state.apiClientId}
                                    placeholder="Enter API client ID"
                                />
                                <div className="invalid-feedback">
                                    Please provide an API client ID.
                                </div>
                            </MDBCol>
                        </MDBRow>

                        <MDBRow>
                            <MDBCol col="12" sm="12" lg="12">
                                <label
                                    htmlFor="apiClientSecret"
                                    className="black-text"
                                >
                                    API Client Secret *
                                </label>
                                <input
                                    required
                                    id="apiClientSecret"
                                    name="apiClientSecret"
                                    type="password"
                                    className="form-control"
                                    onChange={this.changeHandler}
                                    value={this.state.apiClientSecret}
                                    placeholder="Enter API client secret"
                                />
                                <div className="invalid-feedback">
                                    Please provide an API client secret.
                                </div>
                            </MDBCol>
                        </MDBRow>

                        <MDBRow>
                            <MDBCol col="12" sm="12" lg="12">
                                <MDBInput
                                    label="Enable Sync"
                                    type="checkbox"
                                    id="enableSync"
                                    name="enableSync"
                                    onChange={this.toggleEnableSync}
                                    checked={this.state.enableSync}
                                />
                            </MDBCol>
                        </MDBRow>

                        <div className="text-right submitButton">
                            <MDBBtn color="danger" type="submit">
                                {this.props.loading_ruckus === true ? (
                                    <div
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                    >
                                        <span className="sr-only">
                                            Loading...
                                        </span>
                                    </div>
                                ) : (
                                    "Add Ruckus R1 Controller"
                                )}
                            </MDBBtn>
                            <MDBBtn
                                color="primary"
                                onClick={this.props.toggleAddRuckusR1}
                            >
                                Close
                            </MDBBtn>
                        </div>
                    </form>
                </MDBModalBody>
            </>
        );
    }
}

export default withTranslation()(AddRuckusR1);
